import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from '../services/claims.service';

@Injectable()
export class MeteringGuard {

    constructor(
        private router: Router,
        private claimsService: ClaimsService
    ) { }

    canActivate() {
        const hasConsumptionRole = this.claimsService.hasConsumptionFeature() || this.claimsService.isSuperUser();
        if (!hasConsumptionRole) {
            this.router.navigate(['/auth/logout']);
        }

        return hasConsumptionRole;
    }
}
